import { render, staticRenderFns } from "./PermissionCheckboxes.vue?vue&type=template&id=b139499c&scoped=true"
import script from "./PermissionCheckboxes.vue?vue&type=script&lang=js"
export * from "./PermissionCheckboxes.vue?vue&type=script&lang=js"
import style0 from "./PermissionCheckboxes.vue?vue&type=style&index=0&id=b139499c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b139499c",
  null
  
)

export default component.exports